import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import Navbar from './components/Navbar/Navbar';
import TopNavScrim from './components/Navbar/TopNavScrim';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SmartTreasuryPage from './pages/SmartTreasuryPage';
import NotFoundPage from './pages/NotFoundPage';
import OnboardingPage from './pages/OnboardingPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import PqrHabeasDataPage from './pages/PqrHabeasDataPage';
import FloatingCortex from './components/FloatingCortex/FloatingCortex';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import ScrollProgress from './components/ScrollProgress/ScrollProgress';
import './index.css';

// Checkout de pagos: chunk aparte, solo lo descarga quien abre /checkout.
const CheckoutApp = lazy(() => import('./features/checkout/CheckoutApp'));

const isCheckoutPath = (pathname) => pathname === '/checkout' || pathname.startsWith('/checkout/');

/** Navbar, footer y widgets del sitio; el checkout va sin ellos. */
function SiteChrome({ children }) {
  const { pathname } = useLocation();
  return isCheckoutPath(pathname) ? null : children;
}

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    const onHomeServices =
      location.pathname === '/' &&
      (location.hash === '#services' || location.state?.scrollToServices === true);
    if (onHomeServices) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash, location.state]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SiteChrome>
        <ScrollProgress />
      </SiteChrome>
      <a href="#main-content" className="skip-link">Saltar al contenido</a>
      <SiteChrome>
        <Navbar />
        <TopNavScrim />
      </SiteChrome>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/smart-treasury" element={<SmartTreasuryPage />} />
        <Route path="/services" element={<Navigate to={{ pathname: '/', hash: '#services' }} replace />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/pqr-habeas-data" element={<PqrHabeasDataPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route
          path="/checkout/*"
          element={
            <Suspense fallback={<div className="min-h-screen bg-[#0F0F0F]" />}>
              <CheckoutApp />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <SiteChrome>
        <Footer />
        <FloatingCortex />
        <WhatsAppButton />
      </SiteChrome>
    </Router>
  );
}

export default App;
